import moment from 'moment'
import { getUserLang } from '@/plugins/lang'

export function setMomentLocale() {
    let lang = getUserLang().toLowerCase()

    if (lang === 'pt-br') {
        moment.updateLocale(lang, {
            weekdaysMin : ["Do", "Se", "Te", "Qu", "Qu", "Sex", "Sab"],
        });
    }

    moment.locale(lang)
}

function timeToString(number) {
    if(number < 10) {
        return '0' + number
    }

    return number.toString()
}

export function durationToTimeFormat(moment, unitPrecision = 'minutes') {
    let value = timeToString(Math.floor(moment.asHours())) + ':' + timeToString(moment.minutes())

    if(unitPrecision === 'seconds') {
        value += ':' + timeToString(moment.seconds())
    }

    return value
}

export function getPrevMonth(date, format) {
    return moment(date, format).subtract(1,'months').format(format)
}

export function parseUnixToTimeFormat(unix, unitPrecision = 'minutes') {
    return durationToTimeFormat(moment.duration(unix, 'seconds'), unitPrecision)
}

export function parseTimeToUnixFormat(time) {
    return moment.duration(time).asSeconds()
}

export function dateIsValid(date, format) {
    return moment(date, format, true).isValid()
}

export function isFutureDate(date, format) {
    return moment(date, format).diff(moment()) > 0
}

export function nowFormat() {
    return moment().format(dateFormat().moment.dateTime)
}

export function getTimeFromDateTime(dateTime) {
    return dateTime ? dateTime.slice(-5).trim() : ''
}

export function getHumanDateFromDateTime(dateTime) {
    return moment(dateTime, dateFormat().moment.dateTime).format('LL')
}

export function getDateTimeFromNow(dateTime) {
    return moment(dateTime, dateFormat().moment.dateTime).fromNow()
}

export function getDateFromDateTime(dateTime) {
    return dateTime ? dateTime.slice(0, 10).trim() : ''
}

const listFormatDates = {
    'en': {
        moment: {
            date: 'YYYY-MM-DD',
            dateTime: 'YYYY-MM-DD HH:mm',
            monthYear: 'YYYY-MM',
        },

        inputMask: {
            date: 'yyyy-mm-dd',
            dateTime: 'yyyy-mm-dd HH:MM',
            monthYear: 'yyyy-mm',
        },

        placeholder: {
            date: '____-__-__',
            dateTime: '____-__-__ __:__',
            monthYear: '____-__',
        },
    },

    'es': {
        moment: {
            date: 'DD/MM/YYYY',
            dateTime: 'DD/MM/YYYY HH:mm',
            monthYear: 'MM/YYYY',
        },

        inputMask: {
            date: 'dd/mm/yyyy',
            dateTime: 'dd/mm/yyyy HH:MM',
            monthYear: 'mm/yyyy',
        },

        placeholder: {
            date: '__/__/____',
            dateTime: '__/__/____ __:__',
            monthYear: '__/____',
        },
    },

    'pt-BR': {
        moment: {
            date: 'DD/MM/YYYY',
            dateTime: 'DD/MM/YYYY HH:mm',
            monthYear: 'MM/YYYY',
        },

        inputMask: {
            date: 'dd/mm/yyyy',
            dateTime: 'dd/mm/yyyy HH:MM',
            monthYear: 'mm/yyyy',
        },

        placeholder: {
            date: '__/__/____',
            dateTime: '__/__/____ __:__',
            monthYear: '__/____',
        },
    },

    useLang: null,
}

export function dateFormat() {
    listFormatDates.useLang = listFormatDates.useLang || getUserLang()

    return listFormatDates[listFormatDates.useLang]
}
